// removed by extract-text-webpack-plugin
module.exports = {"iconOrder":"index__iconOrder___3RmlQ","ascending":"index__ascending___3ekP_","active":"index__active___kDp3R","restriction":"index__restriction___XlPpP"};


//////////////////
// WEBPACK FOOTER
// ./src/views/DashboardSettings_Slot/components/Table/components/index.less
// module id = 662
// module chunks = 3